import { combineReducers } from 'redux';
import loading from './loading';
import error from './error';
import toasts from './toasts';
import modal from './modal';
import general from './general';
import { ChildReducerName } from '../constants';
export const coreReducer = combineReducers({
    [ChildReducerName.loading]: loading,
    [ChildReducerName.error]: error,
    [ChildReducerName.toasts]: toasts,
    [ChildReducerName.modal]: modal,
    [ChildReducerName.general]: general,
});
export default coreReducer;
